<template>
  <header class="default-header">

    <div class="header-inner">

      <!-- ЛЕВАЯ ЧАСТЬ -->

      <div
        class="header-left"
        :style="{ marginLeft: `calc(50% - ${props.offset}px)` }"
      >

        <img
          src="../assets/hr3logo.png"
          alt="HR3"
          class="header-logo"
          @click="goToFeed"
        />

        <button
          class="back-button"
          type="button"
          @click="goBack"
          aria-label="Назад"
        >
          <img
            src="../assets/back-icon.png"
            alt=""
            class="back-icon"
          />
        </button>

        <div class="header-title-wrapper">

          <template v-if="!props.loading">

            <h1 class="header-title">
              {{ title }}
            </h1>

          </template>

          <template v-else>

            <div class="title-skeleton shimmer"></div>

          </template>

        </div>

      </div>

    </div>

    <div class="header-separator"></div>

  </header>
</template>

<script setup>

import {
  defineProps,
  defineEmits,
  ref,
  onMounted,
  onBeforeUnmount
} from "vue";

import { useRouter } from "vue-router";

const emit = defineEmits(["back"]);

const props = defineProps({
  title: String,
  emitBack: {
    type: Boolean,
    default: false
  },
  offset: {
    type: Number,
    default: 600
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const router = useRouter();

const isLightTheme = ref(false);

let observer = null;

onMounted(() => {

  const headerWidth = 1200;
  const offset = headerWidth / 2;

  document.documentElement.style.setProperty(
    "--header-width",
    `${headerWidth}px`
  );

  document.documentElement.style.setProperty(
    "--header-offset",
    `${offset}px`
  );

  const updateTheme = () => {

    isLightTheme.value =
      document.documentElement.getAttribute("data-theme") === "light";

  };

  updateTheme();

  observer = new MutationObserver(updateTheme);

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"]
  });

});

onBeforeUnmount(() => {

  observer?.disconnect();

});

const goBack = () => {

  if (props.emitBack) {
    emit("back");
    return;
  }

  if (window.history.length > 2) {
    router.back();
  } else {
    router.push("/feed");
  }

};

const goToFeed = () => {

  router.push("/feed");

};

</script>


<style scoped>

.default-header{
    width:100%;
    height:70px;

    position:relative;

    display:flex;
    flex-direction:column;
    justify-content:center;

    background:var(--header-bg-dark);

    backdrop-filter:blur(18px);

    transition:
        background .25s ease,
        box-shadow .25s ease;

    box-shadow:
        0 2px 18px rgba(0,0,0,.06);
}

[data-theme="light"] .default-header{
    background:var(--header-bg-light);
}

/* ===================================== */

.header-inner{

    width:100%;
    height:100%;

    display:flex;
    align-items:center;

    padding:0 20px;

}

.header-left{

    width:1200px;

    display:flex;
    align-items:center;

    padding:0 20px;

}

/* ===================================== */

.header-logo{

    width:40px;
    height:auto;

    object-fit:contain;

    cursor:pointer;

    margin-left:-20px;
    margin-right:40px;

    transition:
        transform .25s ease,
        opacity .25s ease;

}

.header-logo:hover{

    transform:scale(1.08);

}

/* ===================================== */

.back-button{

    width:36px;
    height:36px;

    padding:8px;

    display:flex;
    align-items:center;
    justify-content:center;

    border:none;
    outline:none;

    border-radius:50%;

    cursor:pointer;

    background:rgba(255,255,255,.05);

    backdrop-filter:blur(10px);

    margin-right:18px;

    transition:
        transform .2s ease,
        background .2s ease,
        box-shadow .2s ease;

}

[data-theme="light"] .back-button{

    background:#F3F3F3;

}

.back-button:hover{

    transform:translateX(-2px);

    background:rgba(255,255,255,.10);

    box-shadow:
        0 8px 18px rgba(0,0,0,.12);

}

[data-theme="light"] .back-button:hover{

    background:#EAEAEA;

}

.back-button:active{

    transform:scale(.96);

}

.back-icon{

    width:16px;
    height:16px;

    object-fit:contain;

    flex-shrink:0;

    transition:transform .2s ease;

}

.back-button:hover .back-icon{

    transform:translateX(-2px);

}

[data-theme="light"] .back-icon{

    filter:invert(1);

}

/* ===================================== */

.header-title-wrapper{

    display:flex;
    align-items:center;

    min-height:26px;

}

.header-title{
    margin:0;
    font-size:15px;
    font-family:"Eastman-Bold",sans-serif;
    color:var(--header-text-dark);
    letter-spacing:.2px;
    transition:color .25s ease;
}

[data-theme="light"] .header-title{
    color:var(--header-text-light);
}

/* ===================================== */

.header-separator{

    position:absolute;

    left:0;
    right:0;
    bottom:0;

    height:1px;

    background:
        linear-gradient(
            90deg,
            transparent,
            var(--separator-dark),
            transparent
        );

    opacity:.55;

}

[data-theme="light"] .header-separator{

    background:
        linear-gradient(
            90deg,
            transparent,
            var(--separator-light),
            transparent
        );

}

/* ===================================== */
/* Skeleton */
/* ===================================== */

.title-skeleton{

    width:180px;
    height:16px;

    border-radius:8px;

    overflow:hidden;

    position:relative;

    background:#383838;

}

[data-theme="light"] .title-skeleton{

    background:#DDDDDD;

}

.shimmer::before{

    content:"";

    position:absolute;

    inset:0;

    background:
        linear-gradient(
            90deg,
            transparent,
            rgba(255,255,255,.35),
            transparent
        );

    animation:
        shimmer 1.4s linear infinite;

}

@keyframes shimmer{

    from{

        transform:translateX(-100%);

    }

    to{

        transform:translateX(100%);

    }

}

/* ===================================== */
/* Mobile */
/* ===================================== */

@media (max-width:768px){

.default-header{

    height:60px;

}

.header-inner{

    padding:0 16px;

}

.header-left{

    width:100%;

    margin-left:0 !important;

    padding:0;

}

.header-logo{

    width:32px;

    margin-left:0;
    margin-right:14px;

}

.back-button{

    width:34px;
    height:34px;

    margin-right:14px;

}

.back-icon{

    width:15px;
    height:15px;

}

.header-title{

    font-size:14px;

}

}

</style>